import { useCallback, useContext, useEffect, useMemo, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { routes } from '../constants/routes';
import { AppContext } from '../contexts/app/context';
import { ErrorContext } from '../contexts/error/context';
import { isAcceptanceTest } from '../utils/general';
const defaultOptions = {
  cancelOnUnmount: true,
  forceRefresh: false
};
const useInterval = (fn, interval, options = defaultOptions) => {
  const location = useLocation();
  const timeout = useRef(undefined);
  const callback = useRef(fn);
  const isPlannerPage = useMemo(() => location.pathname.endsWith(routes.outsideMeeting), [location]);
  const skipRefreshRef = useRef(false);
  const {
    showError
  } = useContext(ErrorContext);
  const {
    isPageHidden,
    skipRefresh,
    selectors: {
      isInLiveMeeting
    }
  } = useContext(AppContext);
  const stopIntervalRefresh = useMemo(() => isPageHidden || skipRefresh || showError, [isPageHidden, showError, skipRefresh]);

  // clear timeout on unmount
  const clear = useCallback(() => {
    if (timeout.current) {
      clearInterval(timeout.current);
    }
  }, []);

  // Update skipRefreshRef when skipRefresh changes
  const setSkipRefresh = useCallback(() => {
    skipRefreshRef.current = true;
  }, []);

  // if the provided function changes, change its reference
  useEffect(() => {
    if (fn && typeof fn === 'function') {
      callback.current = fn;
    }
  }, [fn]);

  // reset the timeout on interval change
  useEffect(() => {
    if (typeof interval === 'number' && (isInLiveMeeting || isPlannerPage) && !isAcceptanceTest) {
      clearInterval(timeout.current);
      timeout.current = setInterval(() => {
        // check and run if we have some function in ref
        if (callback.current && typeof callback.current === 'function' && (!stopIntervalRefresh || options.forceRefresh) && !skipRefreshRef.current) {
          callback.current(setSkipRefresh);
        }
      }, interval);
    }

    // clean previous interval
    return clear;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [interval, stopIntervalRefresh, isInLiveMeeting, options.forceRefresh]);

  // clear timeout on unmount
  useEffect(() => () => {
    if (options.cancelOnUnmount) {
      clear();
    }
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  []);
  return [];
};
export default useInterval;